import type { FunctionComponent } from 'react';

import { type Theme, useTheme } from '@dr.pogodin/react-utils';

import defaultTheme from './default.theme.scss';

type ThemeT = Theme<'container' | 'label' | 'waveBar' | 'waveForm'>;

type PropsT = {
  mini?: boolean;
  theme?: ThemeT;
};

export const Listening: FunctionComponent<PropsT> = ({ mini, theme }) => {
  const composed = useTheme('Listening', defaultTheme, theme);
  return (
    <div className={composed.container}>
      <div className={composed.waveForm}>
        <div className={composed.waveBar} />
        <div className={composed.waveBar} />
        <div className={composed.waveBar} />
        <div className={composed.waveBar} />
        <div className={composed.waveBar} />
        {mini ? null : (
          <>
            <div className={composed.waveBar} />
            <div className={composed.waveBar} />
            <div className={composed.waveBar} />
            <div className={composed.waveBar} />
          </>
        )}
      </div>
      <div className={composed.label}>Listening...</div>
    </div>
  );
};
